export type Preferences = {
  push?: {
    [key: string]: boolean
  }
  sms?: {
    [key: string]: boolean
  }
  // TODO: uncomment when email endpoint is available
  // email?: {
  //   [key: string]: boolean
  // }
}

// Appointment reminders and intake reminders are grouped together
const REMINDERS = ['appointmentReminders', 'intakeReminders']

export const ICONS_MAPPING = {
  messagesAndVideoCalls: 'cellphone-message',
  reminders: 'bell-badge-outline',
  challengeUpdates: 'trophy-outline',
  brandNewContent: 'star-outline',
  importantAnnouncements: 'bullhorn-outline',
  wbiReminders: 'speedometer-medium',
}

export const PREFERENCE_MAPPING = {
  // TODO: uncomment when email endpoint is available
  // email: ['intakeReminders'],
  push: [
    'messagesAndVideoCalls',
    'brandNewContent',
    'challengeUpdates',
    'habitReminders',
    'importantAnnouncements',
    'wbiReminders',
    'intakeReminders',
  ],
  sms: ['appointmentReminders'],
}

export const buildNotificationCenterData = (preferences: Preferences) => {
  const pushNotifications = ['messagesAndVideoCalls', ...Object.keys(preferences?.['push'] || {})]
  const smsNotifications = Object.keys(preferences?.['sms'] || {})
  // TODO: uncomment when email endpoint is available, and add it to the notifications array
  // const emailNotifications = Object.keys(preferences?.['email'] || {})

  // Dedupe the combined array first
  const allNotifications = [...new Set([...pushNotifications, ...smsNotifications])]

  // Check if we have any reminder types
  const hasReminders = allNotifications.some((n) => REMINDERS.includes(n))

  // Filter out individual reminder types
  const withoutReminderTypes = allNotifications.filter(
    (notification) => !REMINDERS.includes(notification)
  )

  if (hasReminders) {
    const [first, ...rest] = withoutReminderTypes

    return [first, 'reminders', ...rest]
  }

  return withoutReminderTypes
}

export const buildSMSPreference = (
  appointmentReminders: boolean = true,
  isEnabled: boolean = true
) => {
  const preference = {
    appointment_reminders: appointmentReminders,
    is_enabled: isEnabled,
  }
  return { sms: preference }
}
